import { AuthRequest, Method } from 'src/util/Request';
import { baseUrl, genericNetworkErrorHandler } from '.';

export const getShipmentTrackingRoutes = async (filters: any) => {
    const url = `${baseUrl}/shipmentTracker/routes/search`;

    const headers = {
        'Content-Type': 'application/json',
    };

    const res = await AuthRequest(url, Method.POST, headers, filters);

    if (res.ok) {
        const report = await res.json();
        return report.data;
    } else {
        await genericNetworkErrorHandler(res);
    }
};

export const getRouteStops = async (routeId: string) => {
    const url = `${baseUrl}/shipmentTracker/route/stops/${routeId}`;

    const res = await AuthRequest(url, Method.GET);

    if (res.ok) {
        const report = await res.json();
        return report.data;
    } else {
        await genericNetworkErrorHandler(res);
    }
};

export const getLocationShipmentTrackingDetails = async (locationId: string, startDate: Date, endDate: Date | null) => {
    const url = `${baseUrl}/shipmentTracker/location/${locationId}?startDate=${startDate.toISOString()}&endDate=${
        endDate ? endDate.toISOString() : null
    }`;

    const res = await AuthRequest(url, Method.GET);

    if (res.ok) {
        const report = await res.json();
        return report.data;
    } else {
        await genericNetworkErrorHandler(res);
    }
};
